import { styled } from 'styled-components';

export const StyledLogo = styled.img<{ $maxHeight?: string }>`
  max-width: 100%;
  max-height: ${({ $maxHeight }) => $maxHeight || '68px'};
  align-self: center;
  margin-bottom: 20px;

  @media (max-width: 768px) {
    max-height: 100px;
  }
`;
